import { render, staticRenderFns } from "./PokemonAdder.vue?vue&type=template&id=649e6313&scoped=true&"
import script from "./PokemonAdder.vue?vue&type=script&lang=js&"
export * from "./PokemonAdder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e6313",
  null
  
)

export default component.exports